// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { MonolithImageSizeFragmentDoc } from '../../useImageProps.generated';
export const ThreeSixtyFragmentDoc = gql`
    fragment threeSixty on GenericImage {
  url
  size: size(name: LARGE) {
    ...monolithImageSize
  }
  size_x2: size(name: LARGE_X2) {
    ...monolithImageSize
  }
}
    ${MonolithImageSizeFragmentDoc}`;